//西班牙语
export default {
  Login: {
    Title: "Inicia sesión en tu cuenta",
    describe: "Por favor, inicia sesión o crea una cuenta para comenzar.",
    Google: "Continuar con Google",
    Apple: "Continuar con Apple",
    or: "O",
    Emailplaceholder: "Dirección de correo electrónico",
    Passwordplaceholder: "Contraseña",
    Login: "Iniciar sesión",
    forgot: "¿Olvidaste tu contraseña?",
    notAccount: "¿No tienes una cuenta de Fineshare?",
    Signup: "Registrarse",
    InvalidEmail: "Formato de correo electrónico inválido.",
    InvalidPassword: "La contraseña debe tener al menos 6 caracteres.",
    loading: "Cargando...",
    login: "Iniciar sesión",
    errorText:
      "Error al iniciar sesión, por favor revisa tu nombre de usuario y contraseña",
  },
  signup: {
    Title: "Crea tu cuenta",
    describe: "Crea tu cuenta de Fineshare en segundos.",
    Google: "Registrarse con Google",
    Apple: "Registrarse con Apple",
    or: "O",
    Emailplaceholder: "Ingresa la dirección de correo electrónico",
    Passwordplaceholder: "Ingresa una contraseña de 6 dígitos",
    Already: "¿Ya tienes una cuenta?",
    Login: "Iniciar sesión",
    By: "Al crear una cuenta, acepto que he leído y acepto la",
    Privacy: "Política de privacidad",
    Terms: "Términos de uso.",
    and: "y",
    signupText: "Crea tu cuenta",
    InvalidEmail: "Formato de correo electrónico inválido.",
    InvalidPassword: "La contraseña debe tener al menos 6 caracteres.",
    loading: "Cargando...",
    passwordError: "La dirección de correo electrónico ya ha sido registrada",
    again: "Estás haciendo demasiadas solicitudes, por favor intenta más tarde",
    Registration:
      "Registro fallido, por favor revisa tu correo electrónico y contraseña.",
    hasRegistered: "La dirección de correo electrónico ya ha sido registrada",
    Title2: "Crea tu cuenta de Fineshare",
  },
  Home: {
    Welcome: "Bienvenido al Centro de Cuentas Fineshare",
    Hi: "Hola,",
    Order: "Mis Pedidos",
    orders: "Ver nuestros pedidos de compra",
    Learn: "Aprende más",
    Product: "Gestionar Productos",
    products: "Ver mis productos comprados",
    Setting: "Configuración de la Cuenta",
    Settings: "Detalles de la cuenta y cambia tu contraseña",
    account: "Saca el máximo provecho de tu cuenta",
    FineCam: "FineCam",
    FineCams: "Crea y comparte tus videos inspiradores en cualquier lugar",
    FineVoice: "FineVoice",
    FineVoices: "Crea locuciones con tus voces favoritas, a tu manera",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Transforma tu voz, transmite tus emociones",
    Singify: "Singify",
    Singifys: "Crea versiones AI con las voces que desees",
  },
  success: {
    Congratulations: "¡Felicidades!",
    successfully: "Tu cuenta Fineshare ha sido creada con éxito.",
  },
  successapp: {
    Successful: "¡Inicio de sesión exitoso!",
    successfully1:
      "Has iniciado sesión con éxito en tu cuenta de Fineshare y ahora puedes comenzar a usar la aplicación.",
    successfully2:
      "Has iniciado sesión con éxito en tu cuenta de Fineshare. Ahora puedes cerrar esta ventana y comenzar a usar la aplicación.",
    Go: "Ir al Centro de Usuarios de Fineshare",
  },
  forgot: {
    ForgotPas: "¿Olvidaste tu contraseña?",
    Enter1: "Ingresa el correo para restablecer la contraseña",
    Enter2:
      "Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
    exmple: "nombre@ejemplo.com",
    Back: "Volver al inicio de sesión",
    submitText: "Enviar",
    errorText: "Por favor ingresa tu dirección de correo electrónico",
    loading: "cargando...",
    sent: "Hemos enviado un correo a tu dirección de correo electrónico",
    notExist: "Tu correo electrónico no existe, por favor confirma tu correo",
    Reset: "Restablecimiento fallido, por favor confirma tu correo electrónico",
  },
  account: {
    Settings: "Configuración de Cuenta",
    Change: "Cambia tus detalles de cuenta, contraseñas y más.",
    Personal: "Información Personal",
    email: "Correo electrónico:",
    Name: "Nombre de usuario:",
    Edit: "Editar",
    title: "Cambiar nombre de usuario",
    message: "El nombre ingresado no puede estar vacío.",
    placeholder: "Por favor, ingresa tu nombre de usuario",
    Reset: "Restablecer Contraseña",
    Resets:
      "Puedes restablecer tu contraseña, ingresa 6 o más números y contraseña",
    ResetPas: "Restablecer Contraseña",
    Delete: "Eliminar Cuenta",
    Deletes:
      "Esto eliminará permanentemente tu cuenta y todos sus datos, y no podrás reactivar esta cuenta.",
    sure: "¿Estás seguro de que deseas eliminar tu cuenta de Fineshare?",
    sures:
      "Una vez que tu cuenta sea eliminada, todos tus datos en Fineshare serán eliminados permanentemente. Para proceder con la eliminación de la cuenta, hemos enviado un código de verificación. Ingresa el código y haz clic en Confirmar.",
    Deletebtn: "Eliminar",
    Deleteplaceholder:
      "Por favor, ingresa el código de verificación de 6 dígitos",
  },
  order: {
    Order: "Mis Pedidos",
    history: "Tu historial de pedidos ha sido registrado en esta página",
    dont: "Aún no tienes productos",
    Buy: "Compra ahora para obtener más optimización, haz clic en el botón de abajo para obtenerlo ahora",
    BuyBtn: "Comprar Ahora",
    OrderId: "ID del Pedido:",
    Price: "Precio:",
    Date: "Fecha del Pedido:",
  },
  Product: {
    Product: "Mi Producto",
    products: "Los productos registrados en tu cuenta",
    dont: "Aún no tienes productos",
    Management: "Gestionar Dispositivos >",
  },
  redeem: {
    Redeem: "Canjear Membresía",
    products: "Aquí puedes canjear productos Fineshare",
    Please: "Por favor, ingresa tu código de canje",
    placeholder: "Código de canje",
    Submit: "Enviar",
    Notes: "Notas:",
    Notes1: "1.Formato del código de canje: XXXXX;",
    Notes2:
      "2.Para ver tus productos canjeados, haz clic en el menú 'Producto'.",
    Successfully: "Canje exitoso",
    Follow: "Sigue los siguientes pasos para comenzar a usar VoiceTrans:",
    step1: "1. Descarga e instala Fineshare VoiceTrans.",
    step2: "2. Abre VoiceTrans y ve a ",
    Account: "Cuenta",
    step3:
      "3. Ingresa tu correo electrónico y contraseña para iniciar sesión en tu cuenta Fineshare.",
    Tips: "Consejos: Para un mejor uso, por favor lee el ",
    guide: "guía",
    Redemption: "Fallo en el Canje",
    redeemed:
      "El código de canje ya ha sido utilizado. Por favor, abre el software e inicia sesión en tu cuenta nuevamente para comenzar a usarlo.",
    Failed: "Fallo en el canje",
    check: "Por favor revisa tu código de canje.",
  },
  details: {
    Product: "Mi Producto",
    products: "Todos los productos que has comprado están en esta página",
    Back: "Volver a la lista",
    Name: "Nombre del dispositivo",
    system: "Sistema del dispositivo",
    status: "Estado del dispositivo",
    Operation: "Operación",
    Delete: "Eliminar",
    contact:
      "La eliminación directa no está soportada actualmente. Si necesitas eliminar el dispositivo, por favor contáctanos en ",
  },
  nav: {
    Home: "Inicio",
    Account: "Cuenta",
    Order: "Pedido",
    Product: "Producto",
    Redeem: "Canjear",
    Help: "Centro de Ayuda",
  },
  auth: {
    Authorization: "¡Autorización exitosa!",
    wait: "Volviendo a la aplicación, por favor espere...",
  },
  notfound: {
    Not: "Página No Encontrada",
    Unfortunately:
      "Desafortunadamente, la página que busca no existe o hay un error en el enlace que ingresó.",
    Home: "Ir a la página de inicio",
  },
  topuser: {
    Settings: "Configuraciones de la Cuenta",
    language: "Idioma",
    Logout: "Cerrar sesión",
  },
  loginweb: {
    Conversion: "La conversión está a punto de comenzar",
    currently: "Actualmente hay ",
    people: " personas en la fila!",
    Please:
      "Por favor, inicie sesión y le enviaremos los resultados por correo electrónico una vez que se complete la conversión.",
    dont: "No quiero iniciar sesión",
  },
  mobilelogin: {
    Welcome: "¡Bienvenido a Fineshare! Inicia sesión para comenzar.",
  },
  reset: {
    Reset: "Restablecer una nueva contraseña",
    Password:
      "La contraseña debe tener al menos 6 caracteres, con al menos 1 letra y 1 número.",
    password: "Ingrese su nueva contraseña",
    Back: "Volver a iniciar sesión",
    Congratulations: "¡Felicidades!",
    successfully:
      "Contraseña restablecida con éxito, inicie sesión de inmediato",
    Login: "Iniciar sesión",
    Please: "Ingrese 6 dígitos y letras",
    failed:
      "Restablecimiento de contraseña fallido, haga clic en el enlace de restablecimiento en el correo electrónico",
  },
  verification: {
    verification: "Ingrese el código de verificación",
    haveverification: "Hemos enviado un código de verificación a ",
    Please: ". Ingrese el código de verificación que recibió a continuación:",
    Enter: "Ingrese el código de verificación de 6 dígitos",
    Resend: "Reenviar código de verificación",
    Wait: "Espere ",
    again: " segundos y reenvíe",
    Verify: "Verificar",
    error: "Error en el código de verificación",
    verificationcode: "Por favor, ingrese el código de verificación",
  },
};
